import { translationsSiteConfig as site, name } from './translationsSiteConfig'

export const config = { site, reactRendererSite: site, name }
export { masterPageConfig } from './translationsMasterPageConfig'
